'use client';

import { Fallback, Image, Root } from '@radix-ui/react-avatar';

import type { ComponentProps, JSX } from 'react';

import { cn } from '~/utils';

export function Avatar({
  className,
  ...props
}: ComponentProps<typeof Root>): JSX.Element {
  return (
    <Root
      data-slot='avatar'
      className={cn(
        'relative flex size-8 shrink-0 overflow-hidden rounded-full',
        className,
      )}
      {...props}
    />
  );
}

export function AvatarImage({
  alt,
  className,
  ...props
}: ComponentProps<typeof Image>): JSX.Element {
  return (
    <Image
      alt={alt}
      data-slot='avatar-image'
      className={cn('aspect-square size-full', className)}
      {...props}
    />
  );
}

export function AvatarFallback({
  className,
  ...props
}: ComponentProps<typeof Fallback>): JSX.Element {
  return (
    <Fallback
      data-slot='avatar-fallback'
      className={cn(
        'bg-muted flex size-full items-center justify-center rounded-full',
        className,
      )}
      {...props}
    />
  );
}
